import { render } from "./RoleMaster.vue?vue&type=template&id=7b356f28&scoped=true"
import script from "./RoleMaster.vue?vue&type=script&lang=js"
export * from "./RoleMaster.vue?vue&type=script&lang=js"

import "./RoleMaster.vue?vue&type=style&index=0&id=7b356f28&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b356f28"]])

export default __exports__